import AddInviteNameBlock from './AddInviteNameBlock';
import AddHostInformationBlock from './AddHostInformationBlock';
import { AddNotesBlock } from './AddNotesBlock';
import AddScheduleBlock from './AddScheduleBlock';
import AddVisitorsBlock from './AddVisitorsBlock';
import VisitorBlockHandler from './VisitorBlockHandler';

const VisitorManagement = {
  AddVisitorsBlock,
  AddScheduleBlock,
  AddHostInformationBlock,
  AddNotesBlock,
  AddInviteNameBlock,
  VisitorBlockHandler,
};

export {
  AddVisitorsBlock,
  AddScheduleBlock,
  AddHostInformationBlock,
  AddNotesBlock,
  AddInviteNameBlock,
  VisitorBlockHandler,
};
export default VisitorManagement;
